<template>
    <div class="validation-error" v-if="validator !== undefined">
        <span v-if="show(validator.between)">
            {{
            $t('errors.Between', {
            f: $t(fieldName),
            min: validator.$params.between.min,
            max: validator.$params.between.max
            })
            }}
        </span>
        <span
            v-if="show(validator.required)"
        >{{ $t('errors.Required', { f: $t(fieldName) }) }}</span>
        <span
            v-if="show(validator.maxLength)"
        >{{ $t('errors.MaxLength', maxLength(fieldName, validator)) }}</span>
        <span
            v-if="show(validator.decimal)"
        >{{ $t('errors.Decimal', { f: $t(fieldName) }) }}</span>
        <span
            v-if="show(validator.fileSize)"
        >{{ $t('errors.FileSize', { f: $t(fieldName) }) }}</span>
        <span
            v-if="show(validator.onlyDecimalsForUS)"
        >{{ $t('errors.Decimal', { f: $t(fieldName) }) }}</span>
        <span
            v-if="show(validator.valueMustBeGreaterThenZeroForCreateBooking)"
        >{{ $t('errors.Required', {f: $t(fieldName)})}}</span>

        <span
            v-if="show(validator.email)"
        >{{ $t('errors.Email', {f: $t(fieldName)})}}</span>
        <span v-if="show(validator.custom)">
          {{$t(errorText, {f: $t(fieldName)})}}
        </span>
    </div>
</template>
<script>
  export default {
      props: {
          fieldName: { required: true },
          validator: { required: true },
          errorText: String
      },

      methods: {
          show(value) {
              if (value !== undefined) {
                  return !value;
              }
              return false;
          },
          maxLength(fieldName, validator) {
              if (validator.$params.maxLength !== undefined) {
                  return { f: this.$t(fieldName), max: validator.$params.maxLength.max };
              }
              return {};
          },
      },
  };
</script>
